import { useCallback } from "react";
import { EntityPreviewsLayout } from "../../shared/layouts/EntityPreviewsLayout";
import type { EntityScope } from "../../shared/scope";
import { AdminBondPreviewsAll } from "./AdminBondPreviewsAll";
import { AdminBondPreviewsClosed } from "./AdminBondPreviewsClosed";
import { AdminBondPreviewsOpen } from "./AdminBondPreviewsOpen";
import { BondMetricsView } from "./bond-metrics/BondMetricsView";

export const AdminBondsView = () => {
	const renderMetrics = useCallback((scope: EntityScope) => <BondMetricsView scope={scope} />, []);

	return (
		<EntityPreviewsLayout
			title="Bonds"
			storageKey="admin_bonds_view"
			enableScope
			renderMetrics={renderMetrics}
			tabs={[
				{
					id: "all",
					label: "All",
					Component: AdminBondPreviewsAll,
				},
				{
					id: "open",
					label: "Open",
					isDefault: true,
					Component: AdminBondPreviewsOpen,
				},
				{
					id: "closed",
					label: "Closed",
					Component: AdminBondPreviewsClosed,
				},
			]}
		/>
	);
};
